var enLang = {
	"Đơn mới tạo": "Created",
	"Chờ thanh toán": "Waiting for payment",
	"Đã thanh toán": "Payment confirmed",
	"Đang xử lý": "Processing",
	"Đã hủy": "Cancelled",
	"Đã giao hàng": "Delivered",
	"Đã trả hàng": "Returned",
	"Chờ duyệt": "Waiting for approval",
	"Chờ xác nhận": "Waiting for confirmation",
	"Trả hàng": "Returning",
	"Đang giao hàng": "Delivering",
	"Hoàn thành": "Completed",
	"Chờ giao hàng": "Waiting for delivery",
	"Đang giao": "Delivering",
	"Đã giao": "Delivered",
	"Đã giao đại lý": "Delivered at agency",
	"Mới": "New",
	"Chờ hàng về": "Waiting for product",
	"Thanh toán trả chậm": "Deferred Payment"
};

export { enLang as default };
